<template>
  <div class="relative size-full">
    <SvgAvatar v-if="showFallback" :text="text" :bg-color="bgColor" class="absolute inset-0 size-full" />
    <img v-if="url" :src="url" :alt="text" class="absolute inset-0 block size-full rounded-full" />
  </div>
</template>

<script>
import SvgAvatar from '@/Components/SvgAvatar.vue'

export default {
  components: {
    SvgAvatar,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: '#7047EB',
    },
    url: {
      type: String,
      default: '',
    },
    showFallback: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
